module.exports = __webpack_public_path__ + "static/media/win.9add55f7.mp3";